import { EducationalItem } from '../models/educational-content-page.interfaces';
import {
  CarMocks,
  CoBrandMocks,
  OthersMocks,
  PartnerFlightsMocks,
  StaysMocks,
  VacationsMocks
} from './educational-entry.mocks';

export const WaysMocks: EducationalItem[] = [
  {
    detail:
      'Flight numbers that include the “DL” airline code will earn you MQDs. This includes only the base fare and any carrier-imposed surcharges. MQDs do not include government-imposed taxes and fees.',
    entry: PartnerFlightsMocks,
    action: {
      url: '',
      label: 'Book a Flight'
    }
  },
  {
    detail:
      'With our special offer, earn $1 MQD for every $20 spent on your Delta SkyMiles Platinum American Express Card, or 1 MQD for every $10 spent on your Delta SkyMiles Reserve American Express Card.',
    entry: CoBrandMocks,
    action: {
      url: 'https://creditcard.delta.com/d/delta/',
      label: 'Learn More About Enrollment'
    }
  },
  {
    detail:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean lectus urna, gravida in ante facilisis, sagittis accumsan arcu. Aenean tincidunt, dui id varius sodales, libero mi fermentum turpis, id lacinia risus odio eu sapien.',
    entry: VacationsMocks,
    action: {
      url: '/us/en/delta-vacations',
      label: 'Book a Vacation'
    }
  },
  {
    detail:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean lectus urna, gravida in ante facilisis, sagittis accumsan arcu. Aenean tincidunt, dui id varius sodales, libero mi fermentum turpis, id lacinia risus odio eu sapien.',
    entry: CarMocks,
    action: {
      url: 'https://www.travelextras-delta.com/Cars#.',
      label: 'Reserve a Car'
    }
  },
  {
    detail:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean lectus urna, gravida in ante facilisis, sagittis accumsan arcu. Aenean tincidunt, dui id varius sodales, libero mi fermentum turpis, id lacinia risus odio eu sapien.',
    entry: StaysMocks,
    action: {
      url: 'https://www.travelextras-delta.com/Hotels#.',
      label: 'Book a Stay'
    }
  },
  {
    detail:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean lectus urna, gravida in ante facilisis, sagittis accumsan arcu. Aenean tincidunt, dui id varius sodales, libero mi fermentum turpis, id lacinia risus odio eu sapien.',
    entry: OthersMocks,
    action: {
      url: '',
      label: ''
    }
  }
];
